/* ═══════════════════════════════════════════════
   STUDIO GRAZIA — Theme JavaScript
   studio-grazia.js
═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {
  const hamburger = document.getElementById('hamburger');
  const drawer = document.getElementById('mobileDrawer');

  if (hamburger && drawer) {
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('is-open');
      drawer.classList.toggle('is-open');
    });
  }

  if ('ontouchstart' in window) {
    document.querySelectorAll('.nav-item > button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        const dropdown = this.nextElementSibling;

        if (dropdown && dropdown.classList.contains('nav-dropdown')) {
          const isOpen = dropdown.style.display === 'block';

          document.querySelectorAll('.nav-dropdown').forEach(function (d) {
            d.style.display = 'none';
          });

          dropdown.style.display = isOpen ? 'none' : 'block';
          e.stopPropagation();
        }
      });
    });

    document.addEventListener('click', function () {
      document.querySelectorAll('.nav-dropdown').forEach(function (d) {
        d.style.display = 'none';
      });
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));

      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  document.querySelectorAll('.newsletter-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      const btn = this.querySelector('button[type="submit"]');

      if (btn) {
        btn.textContent = 'Subscribing...';
        btn.disabled = true;
      }
    });
  });
});